<template>
    <div class="mt-12">
    <Link v-if="gender == 'men'" class="header-class header-link mt-4 !mb-2" href="/mbb-schedules/america-east">{{ gender }}'s America East Standings</Link>
    <div v-else class="header-class mt-2">
        {{ gender }}'s America East Standings
    </div>
        <table class="w-full">
            <thead>
                <tr class="border-b border-slate-600/50">
                    <td class="text-right pr-3">School</td>
                    <td class="text-right">Overall</td>
                    <td class="text-right">Pct</td>
                    <td class="text-right">Conf</td>
                    <td class="text-right">Pct</td>
                    <td class="text-right">Streak</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="s in standings" class="text-slate-400">
                    <td class="text-right pr-3">
                        <Link :href="`/mbb-schedules/america-east/${urlify(s.team.short_name)}`" class="hover:underline hover:text-yellow-200">{{ s.team.school }}</Link>
                    </td>
                    <td class="text-right">{{ s.total_wins }}-{{ s.total_losses }}</td>
                    <td class="text-right">{{ s.total_pct }}</td>
                    <td class="text-right">{{ s.conf_wins }}-{{ s.conf_losses }}</td>
                    <td class="text-right">{{ s.conf_pct }}</td>
                    <td class="text-right font-mono pt-[2px]">{{ s.team.streak }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { urlify } from '@/utils/Utilities';
import { Link } from '@inertiajs/vue3'

export default {
    name: "BasketballStandings",
    props: ['gender', 'standings'],
    components: { Link },
    computed: {},
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        urlify
    }
}
</script>
